export function coerceDiscoverString(value: unknown): string | undefined {
  if (value == null) return undefined;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed || undefined;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return undefined;
}

export function normalizeDiscoverPayload(value: unknown): string | undefined {
  const asString = coerceDiscoverString(value);
  if (asString) return asString;

  if (value != null && typeof value === 'object') {
    try {
      const serialized = JSON.stringify(value);
      return serialized && serialized !== '{}' ? serialized : undefined;
    } catch {
      return undefined;
    }
  }

  return undefined;
}
